<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute}"
    style="position: relative; z-index: 1000"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <a v-if="enableBack" class="nav-back" href="javascript:void(0)" @click="goBack">
          <span class="font-400">
            <md-icon>keyboard_backspace</md-icon>
            Back
          </span>
        </a>
        &nbsp;
        <h3 class="md-title page-title">{{$route.name}}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{toggled: $sidebar.showSidebar}"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <md-list>
            <li class="md-list-item">
              <a class="md-list-item-router md-list-item-container md-button-clean dropdown">
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>person</md-icon>
                    </md-button>
                    <logout />
                  </drop-down>
                </div>
              </a>
            </li>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
export default {
  data() {
    return {
      enableBack: this.$route.meta.enableBack
    };
  },

  computed: {
    navUrl() {
      return this.$store.state.navigate.navUrl;
    }
  },

  methods: {
    goBack() {
      if(this.navUrl) {
        const tempNavUrl = this.navUrl;
        this.$store.dispatch('NAV_URL', '');
        this.$router.push({path: tempNavUrl});
      } else if(this.$route.meta.to) {
        this.$router.push({name: this.$route.meta.to});
      } else {
        window.history.back();
      }
    },

    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    }
  }
};
</script>

<style scoped>
.nav-back {
  width: 70px;
}
</style>
